import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { LinkAnnotationService, MagnificationService, ThumbnailViewService, ToolbarService, NavigationService, TextSearchService, TextSelectionService, PdfViewerModule } from '@syncfusion/ej2-angular-pdfviewer';


@Component({
  selector: 'ocado-pdf-viewer',
  standalone: true,
  imports: [
    DialogModule, PdfViewerModule
  ],
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss',
  providers: [ LinkAnnotationService, MagnificationService, ThumbnailViewService, ToolbarService, NavigationService,
    TextSearchService, TextSelectionService ],
})
export class PDFViewerComponent implements AfterViewInit {
  @Input()
  pdfBase64Url: string = "";

  @Output() cancelBtnEvent: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('Dialog') dialog!: DialogComponent;

  public resource: string = "https://cdn.syncfusion.com/ej2/23.1.43/dist/ej2-pdfviewer-lib";
  ngAfterViewInit(): void {
    setTimeout(() => {
      const viewer = (<any> document.querySelector('.pdfViewer'))?.ej2_instances[ 0 ];
      viewer.load(this.pdfBase64Url, null);
    }, 1000);

  }

  closeDialoge() {
    this.cancelBtnEvent.emit(true);
    this.dialog.destroy();
  }
}
